export default __webpack_public_path__ + "691e62bbe8b61c09c28be29c8e15af6c.png";